import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Phone, Mail, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/brand";

const Footer = () => (
  <footer className="relative mt-20 bg-[#0f1d3a] text-white" data-testid="site-footer">
    <div className="absolute inset-x-0 -top-12 h-12 bg-cream rounded-b-[40%]" aria-hidden />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10 relative">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="Innovative Preschool logo" width="48" height="48" className="h-12 w-12 object-contain bg-white rounded-2xl p-1" />
            <div>
              <div className="font-heading font-bold text-lg">{BRAND.name}</div>
              <div className="text-xs text-white/70">{BRAND.positioning}</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-white/75 leading-relaxed">
            {BRAND.tagline}. A warm Nepalese-concept preschool in {BRAND.location}.
          </p>
        </div>

        <div>
          <h3 className="font-heading text-brand-yellow text-sm tracking-wider uppercase mb-4">Explore</h3>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.slice(0, 6).map((l) => (
              <li key={l.id}>
                <Link to={l.to} className="text-white/80 hover:text-brand-yellow transition" data-testid={`footer-link-${l.id}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-brand-yellow text-sm tracking-wider uppercase mb-4">More</h3>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.slice(6).map((l) => (
              <li key={l.id}>
                <Link to={l.to} className="text-white/80 hover:text-brand-yellow transition" data-testid={`footer-link-${l.id}`}>
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/admin/login" className="text-white/60 hover:text-brand-yellow transition text-xs" data-testid="footer-admin-link">
                Admin Login
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-brand-yellow text-sm tracking-wider uppercase mb-4">Get in Touch</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-brand-yellow" /> <span className="text-white/85">{BRAND.address}</span></li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-brand-yellow" /> <a href={`tel:${BRAND.phone}`} className="text-white/85 hover:text-brand-yellow">{BRAND.phone}</a></li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-brand-yellow" /> <a href={`mailto:${BRAND.email}`} className="text-white/85 hover:text-brand-yellow">{BRAND.email}</a></li>
            <li className="flex items-center gap-2"><Facebook size={16} className="text-brand-yellow" /> <a href={BRAND.facebook} target="_blank" rel="noreferrer" className="text-white/85 hover:text-brand-yellow">Facebook page</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/55">
        <div>© {new Date().getFullYear()} Innovative Preschool. All rights reserved.</div>
        <div>Made with care in Kirtipur, Nepal.</div>
      </div>
    </div>
  </footer>
);

export default Footer;
